<template>
  <div class="box" @click="to()">
    <div class="index">{{index}}</div>
    <!-- <img :src="item.imageUrl" alt="" class="anchor" v-if="item.imageUrl"> -->
        <avatar class="anchor" :text="item.title" :src="item.imageUrl"></avatar>
        <div class="txt">
            <div class="title">
                {{ item.title }}
            </div>
            <div class="commity">
                <avatar class="img" :text="item.shop.name" :src="item.shop.logo" styleText="font-size: 10px;"></avatar>
                <div class="shop">{{ item.shop.name }}</div>
                <avatar class="img" :text="item.brand.name" :src="item.brand.imageUrl" styleText="font-size: 10px;"></avatar>
                <div class="shop">{{ item.brand.name }}</div>
            </div>
            <div class="number">
                <div class="text">
                    <span>价格：</span>
                    <p>¥{{item.price}}</p>
                </div>
                <div class="text">
                    <span>关联视频数：</span>
                    <p>{{item.opusCount}}</p>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import avatar from '@/components/Avatar.vue'
export default {
  props:{
    index:Number,
    info: Object
  },
  components:{
    avatar
  },
  data() {
    return {}
  },
  computed:{
    item() {
        return {
            ...this.info,
            imageUrl: this.info?.imageUrl,//商品图片
        }
    }
  },
  methods: {
    to() {
            this.$router.push({
            path:`/goods/${this.item.itemId}`
        })
    }
  }
}
</script>

<style scoped lang='less'>
.box {
    height: 83px;
    display: flex;
    position: relative;
    align-items: center;
    .index {
        position: absolute;
        top: 2px;
        left: 2px;
        color: #2877FF;
        font-size: 10px;
    }
    .anchor {
        width: 56px;
        height: 56px;
        border-radius: 8px;
        margin-left: 10px;
        margin-right: 8px;
    }
    .txt {
        display: flex;
        flex-direction: column;
        height: 56px;
        justify-content: space-between;
        .title {
            flex: 1;
            width: 265px;
            font-size: 14px;
            font-weight: 500;
            color:#141B27;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .commity {
            flex: 1;
            display: flex;
            align-items: center;
            .img {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }
            .shop {
                width: 94px;
                font-size: 12px;
                 color: #141B27;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .number {
            flex: 1;
            display: flex;
            align-items: flex-end;
            .text {
                display: flex;
                // justify-content: space-between;
                width: 108px;
                font-size: 12px;
                margin-right: 0px;
                span {
                    color: #8E9AAE;
                }
                p {
                    color: #141B27;
                }
            }
        }
    }
}
</style>
